/**
 * Remote Control data type
 */
export enum RemoteControlDataType {
  set_volume= "set_volume",
  set_volume_delta= "set_volume_delta",
  set_channel= "set_channel",
  set_mute= "set_mute",
  BUTTON_TRIGGER= "BUTTON_TRIGGER",
  FLUSH_EVENTS= "FLUSH_EVENTS",
  subscribe= "subscribe",
}
